/**
 * Learning Center Dropdown Pre-selection
 *
 * Pre-selects the current learning center topic in the Categories Dropdown block
 * based on the current URL pathname. Also handles the reset option (-1) to redirect
 * to the parent learning-center page.
 */

export function initLearningCenterDropdownSelection() {
	const selects = document.querySelectorAll( 'select[name="gmr_learning_center"]' );
	if ( ! selects.length ) {
		return;
	}

	// Extract the topic from the URL pathname (e.g., /learning-center/credit-and-borrowing/ -> credit-and-borrowing)
	const topic = location.pathname.split( '/' ).filter( Boolean ).pop();

	// Initialize each dropdown instance
	selects.forEach( ( select ) => {
		// Update the placeholder text to "All topics"
		if ( select.options[ 0 ] ) {
			select.options[ 0 ].text = 'All topics';
		}

		// Check if the topic exists as an option in the select
		if ( topic && [ ...select.options ].some( option => option.value === topic ) ) {
			select.value = topic;
			select.focus();
		}

		// Find the form containing this select
		const form = select.closest( 'form' );

		// Capture phase runs before the block's inline change handler, which treats empty string
		// (the "All topics" reset option) as a redirect to /learning-center/.
		select.addEventListener(
			'change',
			( event ) => {
				if ( select.value !== '' ) {
					return;
				}

				event.preventDefault();
				event.stopImmediatePropagation();
				window.location.href = '/learning-center/';
			},
			true
		);

		// Handle change event to submit form when present (non-reset options only)
		select.addEventListener( 'change', ( event ) => {
			if ( select.value === '' ) {
				return;
			}

			event.preventDefault();
			event.stopPropagation();

			if ( form ) {
				form.submit();
			}
		} );

		// Prevent form submission on enter key to avoid unwanted query parameters
		if ( form ) {
			form.addEventListener( 'submit', ( event ) => {
				// If reset option (empty string) is selected, prevent form submission and redirect instead
				if ( select.value === '' ) {
					event.preventDefault();
					window.location.href = '/learning-center/';
				}
			} );
		}
	} );
}
